import { Component, OnInit, OnDestroy, AfterViewChecked, ElementRef, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { ChatRoom, ChatService, Message, MessageDTO, MessageRequest } from "../../_services/chat.service";
import { UserService } from "../../../services/user-service/user.service";
import { AppUserDTO } from "../../_models/userDTO";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CommonResponse } from "../../_models/Response";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { IMessage } from "@stomp/stompjs";
import { CustomizerSettingsService } from "../../../customizer-settings/customizer-settings.service";
import { MatCard } from "@angular/material/card";
import { DialogService } from "../../_modal/dialog.service";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule,MatCard]
})


export class ChatComponent
  implements OnInit, OnDestroy, AfterViewChecked {

  // ============================================================
  // VIEW
  // ============================================================

  @ViewChild('messagesContainer')
  private messagesContainer!: ElementRef;


  // ============================================================
  // VARIABLES
  // ============================================================

  currentUserId: number | null = null;

  isDarkMode: boolean = false;

  recipientId: number | null = null;

  recipientUsername: string | null = null;

  messageContent = '';

  messages: Message[] = [];

  availableUsers: AppUserDTO[] = [];

  unreadCounts: { [userId: number]: number } = {};

  searchTerm = '';

  lastMessagesByUser: { [userId: string]: MessageDTO } = {};

  lastMessagesByChatRoom: {
    [chatRoomId: number]: MessageDTO
  } = {};

  notificationMessage: string | null = null;

  showDelete: any = null;


  // ============================================================
  // SUBSCRIPTIONS
  // ============================================================

  private subscriptions: Subscription[] = [];


  // ============================================================
  // URL
  // ============================================================

  private baseUrl = environment.base_url;

  private apiUrl = `${this.baseUrl}/api/chat`;


  // ============================================================
  // CONSTRUCTOR
  // ============================================================

  constructor(
    private userService: UserService,
    private http: HttpClient,
    public customizer: CustomizerSettingsService,
    private snackBar: MatSnackBar,
    private chatService: ChatService,
    private dialogService: DialogService
  ) {}


  // ============================================================
  // AFTER VIEW CHECKED
  // ============================================================

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }


  // ============================================================
  // SCROLL
  // ============================================================

  private scrollToBottom(): void {

    try {

      if (!this.messagesContainer) {
        return;
      }

      this.messagesContainer.nativeElement.scrollTop =
        this.messagesContainer.nativeElement.scrollHeight;

    } catch (err) {

      console.log(
        '⚠️ Impossible de scroller automatiquement :',
        err
      );

    }

  }


  // ============================================================
  // INIT
  // ============================================================

  ngOnInit(): void {

    console.log('');
    console.log('================================================');
    console.log('🚀 INITIALISATION DU CHAT');
    console.log('================================================');

    const userIdStr =
      sessionStorage.getItem('user_id');

    const username =
      sessionStorage.getItem('user_username');


    console.log('👤 user_id sessionStorage :', userIdStr);

    console.log(
      '👤 username sessionStorage :',
      username
    );


    if (!userIdStr || !username) {

      console.error(
        '❌ Aucun identifiant utilisateur trouvé dans sessionStorage'
      );

      return;
    }


    this.currentUserId = Number(userIdStr);


    console.log(
      '🆔 currentUserId :',
      this.currentUserId
    );


    // ============================================================
    // WEBSOCKET CONNECTION
    // ============================================================

    console.log('🔌 Connexion WebSocket...');


    this.chatService
      .connect(username)

      .then(() => {

        console.log(
          '✅ WebSocket connecté avec succès'
        );


        console.log(
          '📥 Chargement des messages non lus...'
        );


        this.chatService.fetchUnreadMessages(
          this.currentUserId!
        );

      })

      .catch(err => {

        console.error(
          '❌ Erreur WebSocket :',
          err
        );

      });


    // ============================================================
    // WEBSOCKET MESSAGES
    // ============================================================

    this.subscriptions.push(

      this.chatService
        .onMessage()
        .subscribe({

          next: (msgs: Message[]) => {

            console.log('');
            console.log(
              '================================================'
            );

            console.log(
              '📨 NOUVEAUX MESSAGES REÇUS VIA WEBSOCKET'
            );

            console.log(
              '📦 Nombre de messages :',
              msgs?.length
            );

            console.log(
              '📦 Messages bruts :',
              msgs
            );


            // ----------------------------------------------------
            // LOG DE CHAQUE MESSAGE
            // ----------------------------------------------------

            msgs.forEach((msg, index) => {

              console.log(
                `📩 Message #${index + 1}`,
                {
                  id: msg.id,
                  content: msg.content,
                  senderId: msg.sender?.id,
                  recipientId: msg.recipient?.id,
                  deletedForSender:
                    msg.deletedForSender,
                  deletedForReceiver:
                    msg.deletedForReceiver,
                  seen: msg.seen,
                  timestamp: msg.timestamp
                }
              );

            });


            // ----------------------------------------------------
            // FILTRAGE DES MESSAGES SUPPRIMÉS
            // ----------------------------------------------------

            const filteredMessages =
              this.filterMessagesForCurrentUser(msgs);


            console.log(
              '🧹 Messages après filtrage suppression :',
              filteredMessages
            );


            // ----------------------------------------------------
            // SI UNE CONVERSATION EST OUVERTE
            // ----------------------------------------------------

            if (this.recipientId !== null) {

              console.log(
                '💬 Conversation actuellement ouverte avec :',
                this.recipientId
              );


              this.messages =
                filteredMessages.filter(m =>

                  (
                    m.sender?.id === this.currentUserId &&
                    m.recipient?.id === this.recipientId
                  )

                  ||

                  (
                    m.sender?.id === this.recipientId &&
                    m.recipient?.id === this.currentUserId
                  )

                );


              console.log(
                '💬 Messages affichés dans la conversation :',
                this.messages
              );

            }


            // ----------------------------------------------------
            // REFRESH LAST MESSAGES
            // ----------------------------------------------------

            console.log(
              '🔄 Actualisation des derniers messages...'
            );

            this.loadLastMessages();


            console.log(
              '================================================'
            );

          },

          error: err => {

            console.error(
              '❌ ERREUR WebSocket messages :',
              err
            );

          }

        })

    );


    // ============================================================
    // UNREAD COUNTS
    // ============================================================

    this.subscriptions.push(

      this.chatService
        .unreadCounts$
        .subscribe({

          next: counts => {

            console.log(
              '🔢 Compteurs messages non lus :',
              counts
            );

            this.unreadCounts = counts;

          },

          error: err => {

            console.error(
              '❌ Erreur unreadCounts :',
              err
            );

          }

        })

    );


    // ============================================================
    // NOTIFICATIONS
    // ============================================================

    const notifSub =
      this.chatService
        .notificationReceived$
        .subscribe((notif) => {

          console.log('');
          console.log(
            '📣 NOUVELLE NOTIFICATION'
          );

          console.log(
            '📣 Notification :',
            notif
          );


          this.snackBar.open(
            notif || 'Nouveau message reçu',
            'Fermer',
            {
              duration: 5000,
              panelClass: [
                'notification-snackbar'
              ]
            }
          );

        });


    this.subscriptions.push(
      notifSub
    );


    // ============================================================
    // LOAD USERS
    // ============================================================

    console.log(
      '👥 Chargement des utilisateurs...'
    );


    this.subscriptions.push(

      this.userService
        .getUsers()
        .subscribe({

          next: (res: CommonResponse) => {

            console.log(
              '👥 Réponse getUsers :',
              res
            );


            if (res.status) {

              this.availableUsers =
                (res.data as AppUserDTO[])
                  .filter(
                    u => u.id !== this.currentUserId
                  );


              console.log(
                '👥 Utilisateurs disponibles :',
                this.availableUsers
              );


              this.loadLastMessages();

            }

          },

          error: err => {

            console.error(
              '❌ Erreur getUsers :',
              err
            );

          }

        })

    );


    console.log(
      '================================================'
    );

  }


  // ============================================================
  // FILTRER LES MESSAGES SUPPRIMÉS POUR L'UTILISATEUR CONNECTÉ
  // ============================================================

  private filterMessagesForCurrentUser(
    msgs: Message[]
  ): Message[] {

    console.log('');
    console.log(
      '🧹 FILTRAGE DES MESSAGES POUR L UTILISATEUR'
    );

    console.log(
      '👤 currentUserId :',
      this.currentUserId
    );


    if (this.currentUserId === null) {

      console.warn(
        '⚠️ currentUserId est null'
      );

      return [];

    }


    const result = msgs.filter(msg => {

      // ----------------------------------------------------------
      // SENDER
      // ----------------------------------------------------------

      if (
        msg.sender?.id === this.currentUserId &&
        msg.deletedForSender === true
      ) {

        console.log(
          '🗑️ MESSAGE MASQUÉ POUR LE SENDER',
          {
            id: msg.id,
            content: msg.content,
            deletedForSender:
              msg.deletedForSender
          }
        );

        return false;
      }


      // ----------------------------------------------------------
      // RECEIVER
      // ----------------------------------------------------------

      if (
        msg.recipient?.id === this.currentUserId &&
        msg.deletedForReceiver === true
      ) {

        console.log(
          '🗑️ MESSAGE MASQUÉ POUR LE RECEIVER',
          {
            id: msg.id,
            content: msg.content,
            deletedForReceiver:
              msg.deletedForReceiver
          }
        );

        return false;
      }


      return true;

    });


    console.log(
      '✅ Nombre après filtrage :',
      result.length
    );


    return result;

  }


  // ============================================================
  // SEND MESSAGE WITH NOTIFICATION
  // ============================================================

  sendMessageWithNotification(): void {

    console.log('');
    console.log(
      '================================================'
    );

    console.log(
      '📤 ENVOI MESSAGE + NOTIFICATION'
    );


    console.log(
      '👤 Sender :',
      this.currentUserId
    );

    console.log(
      '👤 Recipient :',
      this.recipientId
    );

    console.log(
      '💬 Content :',
      this.messageContent
    );


    if (
      !this.messageContent.trim() ||
      this.recipientId == null ||
      this.currentUserId == null
    ) {

      console.warn(
        '⚠️ Envoi annulé : données manquantes'
      );

      return;
    }


    const roomId =
      this.generateRoomId(
        this.currentUserId,
        this.recipientId
      );


    console.log(
      '🏠 Room ID :',
      roomId
    );


    const msgRequest: MessageRequest = {

      content:
        this.messageContent.trim(),

      senderId:
        this.currentUserId,

      recipientId:
        this.recipientId,

      roomId,

      timestamp:
        new Date().toISOString(),

      seen: false

    };


    console.log(
      '📦 MessageRequest :',
      msgRequest
    );


    this.chatService
      .sendMessageWithNotification(
        msgRequest
      );


    console.log(
      '✅ Message envoyé'
    );


    this.messageContent = '';


    console.log(
      '================================================'
    );

  }


  // ============================================================
  // TRANSFORM LAST MESSAGES
  // ============================================================

  transformLastMessages(
    rawMessagesById: {
      [key: string]: MessageDTO
    }
  ): {
    [userId: number]: MessageDTO
  } {

    console.log('');
    console.log(
      '================================================'
    );

    console.log(
      '📋 TRANSFORMATION DES DERNIERS MESSAGES'
    );

    console.log(
      '📦 Données reçues :',
      rawMessagesById
    );


    const mapUserToMessage: {
      [userId: number]: MessageDTO
    } = {};


    Object.values(rawMessagesById)
      .forEach(msg => {


        console.log('');
        console.log(
          '🔎 Analyse message :',
          msg
        );


        // --------------------------------------------------------
        // SÉCURITÉ
        // --------------------------------------------------------

        if (this.currentUserId === null) {

          console.warn(
            '⚠️ currentUserId null'
          );

          return;
        }


        // --------------------------------------------------------
        // MESSAGE SUPPRIMÉ POUR SENDER
        // --------------------------------------------------------

        if (
          msg.senderId === this.currentUserId &&
          msg.deletedForSender === true
        ) {

          console.log(
            '🗑️ IGNORÉ : supprimé pour le sender',
            msg
          );

          return;
        }


        // --------------------------------------------------------
        // MESSAGE SUPPRIMÉ POUR RECEIVER
        // --------------------------------------------------------

        if (
          msg.recipientId === this.currentUserId &&
          msg.deletedForReceiver === true
        ) {

          console.log(
            '🗑️ IGNORÉ : supprimé pour le receiver',
            msg
          );

          return;
        }


        // --------------------------------------------------------
        // DÉTERMINER AUTRE UTILISATEUR
        // --------------------------------------------------------

        const otherUserId =
          msg.senderId === this.currentUserId
            ? msg.recipientId
            : msg.senderId;


        console.log(
          '👤 Autre utilisateur :',
          otherUserId
        );


        // --------------------------------------------------------
        // DATE
        // --------------------------------------------------------

        const msgDate =
          msg.timestamp
            ? new Date(msg.timestamp)
            : new Date(0);


        const existingDate =
          mapUserToMessage[otherUserId]?.timestamp
            ? new Date(
                mapUserToMessage[
                  otherUserId
                ].timestamp!
              )
            : new Date(0);


        // --------------------------------------------------------
        // DERNIER MESSAGE
        // --------------------------------------------------------

        if (
          !mapUserToMessage[otherUserId] ||
          msgDate > existingDate
        ) {

          console.log(
            '✅ Nouveau dernier message pour user :',
            otherUserId
          );


          mapUserToMessage[
            otherUserId
          ] = msg;

        }

      });


    console.log('');
    console.log(
      '📋 RESULTAT FINAL LAST MESSAGES :',
      mapUserToMessage
    );

    console.log(
      '================================================'
    );


    return mapUserToMessage;

  }


  // ============================================================
  // UNSEEN INDICATOR
  // ============================================================

  shouldShowUnseenIndicator(
    otherUserId: number
  ): boolean {

    const lastMessage =
      this.lastMessagesByUser[
        otherUserId
      ];


    const result =
      !!lastMessage &&
      !lastMessage.seen &&
      lastMessage.senderId === otherUserId;


    console.log(
      '🔵 Unseen indicator',
      {
        otherUserId,
        lastMessage,
        result
      }
    );


    return result;

  }


  // ============================================================
  // LOAD LAST MESSAGES
  // ============================================================

  loadLastMessages(): void {

    console.log('');
    console.log(
      '================================================'
    );

    console.log(
      '📋 CHARGEMENT DES DERNIERS MESSAGES'
    );

    console.log(
      '👤 currentUserId :',
      this.currentUserId
    );


    if (this.currentUserId === null) {

      console.warn(
        '⚠️ Utilisateur non connecté'
      );

      return;

    }


    console.log(
      '📡 Appel getLastMessages()...'
    );


    this.chatService
      .getLastMessages(
        this.currentUserId
      )

      .subscribe({

        next: (data) => {

          console.log('');
          console.log(
            '📋 DERNIERS MESSAGES REÇUS DU BACKEND'
          );

          console.log(
            '📦 DATA BRUTE :',
            data
          );


          Object.values(data)
            .forEach((msg: MessageDTO) => {

              console.log(
                '📩 LastMessage :',
                {
                  content: msg.content,
                  senderId: msg.senderId,
                  recipientId: msg.recipientId,
                  roomId: msg.roomId,
                  seen: msg.seen,
                  deletedForSender:
                    msg.deletedForSender,
                  deletedForReceiver:
                    msg.deletedForReceiver,
                  timestamp:
                    msg.timestamp
                }
              );

            });


  
          this.lastMessagesByUser =
            this.transformLastMessages(data);


          console.log('');
          console.log(
            '✅ LAST MESSAGES APRÈS TRANSFORMATION :',
            this.lastMessagesByUser
          );

          console.log(
            '================================================'
          );

        },

        error: (err) => {

          console.error('');
          console.error(
            '❌ ERREUR getLastMessages()'
          );

          console.error(
            err
          );

          console.error(
            '================================================'
          );

        }

      });

  }


  // ============================================================
  // SELECT RECIPIENT
  // ============================================================

  onRecipientSelected(
    userId: number
  ): void {

    console.log('');
    console.log(
      '================================================'
    );

    console.log(
      '👤 SÉLECTION CONVERSATION'
    );

    console.log(
      '👤 Current user :',
      this.currentUserId
    );

    console.log(
      '👤 Recipient :',
      userId
    );


    this.recipientId = userId;


    const selectedUser =
      this.availableUsers.find(
        u => u.id === userId
      );


    this.recipientUsername =
      selectedUser?.username || null;


    console.log(
      '👤 Username recipient :',
      this.recipientUsername
    );


    const roomId =
      this.generateRoomId(
        this.currentUserId!,
        this.recipientId
      );


    console.log(
      '🏠 Room ID :',
      roomId
    );


    // ==========================================================
    // JOIN ROOM
    // ==========================================================

    console.log(
      '🔌 Join WebSocket room...'
    );


    this.chatService.joinRoom(
      roomId
    );


    console.log(
      '✅ Room join demandé'
    );


    // ==========================================================
    // MARK SEEN
    // ==========================================================

    console.log(
      '📥 Marquage messages comme vus...'
    );


    this.http
      .put(
        `${this.apiUrl}/mark-seen?roomId=${roomId}&userId=${this.currentUserId}`,
        {}
      )

      .subscribe({

        next: () => {

          console.log(
            '✅ Messages marqués comme vus'
          );


          this.loadLastMessages();


          this.chatService
            .clearUnreadCount(
              this.recipientId!
            );


          console.log(
            '🔢 Compteur unread réinitialisé'
          );

        },

        error: err => {

          console.error(
            '❌ Erreur mark-seen :',
            err
          );

        }

      });


    // ==========================================================
    // LOAD HISTORY
    // ==========================================================

    console.log(
      '📡 Chargement historique conversation...'
    );


    this.chatService
      .getMessagesByRoom(roomId)

      .subscribe({

        next: (msgs: Message[]) => {

          console.log('');
          console.log(
            '📜 HISTORIQUE BRUT REÇU'
          );

          console.log(
            '📦 Nombre :',
            msgs.length
          );

          console.log(
            '📦 Messages :',
            msgs
          );


          msgs.forEach(msg => {

            console.log(
              '📩 Historique message :',
              {
                id: msg.id,
                content: msg.content,
                senderId: msg.sender?.id,
                recipientId: msg.recipient?.id,
                deletedForSender:
                  msg.deletedForSender,
                deletedForReceiver:
                  msg.deletedForReceiver,
                seen: msg.seen,
                timestamp:
                  msg.timestamp
              }
            );

          });


          // ------------------------------------------------------
          // FILTRAGE SUPPRESSION
          // ------------------------------------------------------

          const visibleMessages =
            this.filterMessagesForCurrentUser(
              msgs
            );


          console.log('');
          console.log(
            '🧹 HISTORIQUE APRÈS FILTRAGE :',
            visibleMessages
          );


          // ------------------------------------------------------
          // FILTRAGE CONVERSATION
          // ------------------------------------------------------

          this.messages =
            visibleMessages.filter(m =>

              (
                m.sender?.id === this.currentUserId &&
                m.recipient?.id === this.recipientId
              )

              ||

              (
                m.sender?.id === this.recipientId &&
                m.recipient?.id === this.currentUserId
              )

            );


          console.log('');
          console.log(
            '✅ MESSAGES AFFICHÉS DANS LA CONVERSATION :',
            this.messages
          );


          this.loadLastMessages();


          console.log(
            '================================================'
          );

        },

        error: err => {

          console.error(
            '❌ Erreur chargement historique :',
            err
          );

        }

      });

  }


  // ============================================================
  // SEND MESSAGE
  // ============================================================

  sendMessage(): void {

    console.log('');
    console.log(
      '================================================'
    );

    console.log(
      '📤 ENVOI MESSAGE'
    );


    if (
      !this.messageContent.trim() ||
      this.recipientId == null ||
      this.currentUserId == null
    ) {

      console.warn(
        '⚠️ Envoi annulé : données manquantes'
      );

      return;
    }


    const roomId =
      this.generateRoomId(
        this.currentUserId,
        this.recipientId
      );


    const msgRequest: MessageRequest = {

      content:
        this.messageContent.trim(),

      senderId:
        this.currentUserId,

      recipientId:
        this.recipientId,

      roomId,

      timestamp:
        new Date().toISOString(),

      seen: false

    };


    console.log(
      '📦 MessageRequest :',
      msgRequest
    );


    this.chatService
      .sendMessage(
        msgRequest
      );


    console.log(
      '✅ Message envoyé'
    );


    this.messageContent = '';


    console.log(
      '================================================'
    );

  }


  // ============================================================
  // DELETE MESSAGE
  // ============================================================

  deleteMessage(
    messageId: number
  ): void {

    console.log('');
    console.log(
      '================================================'
    );

    console.log(
      '🗑️ DEMANDE DE SUPPRESSION'
    );

    console.log(
      '📩 Message ID :',
      messageId
    );

    console.log(
      '👤 Current User ID :',
      this.currentUserId
    );


    if (this.currentUserId === null) {

      console.error(
        '❌ Impossible de supprimer : currentUserId null'
      );

      return;
    }


    // ------------------------------------------------------------
    // TROUVER LE MESSAGE AVANT SUPPRESSION
    // ------------------------------------------------------------

    const messageBeforeDelete =
      this.messages.find(
        m => m.id === messageId
      );


    console.log(
      '🔎 MESSAGE AVANT SUPPRESSION :',
      messageBeforeDelete
    );


    if (messageBeforeDelete) {

      console.log(
        '📩 Détails message avant suppression :',
        {
          id: messageBeforeDelete.id,
          content: messageBeforeDelete.content,
          senderId:
            messageBeforeDelete.sender?.id,
          recipientId:
            messageBeforeDelete.recipient?.id,
          deletedForSender:
            messageBeforeDelete.deletedForSender,
          deletedForReceiver:
            messageBeforeDelete.deletedForReceiver
        }
      );

    }


    // ------------------------------------------------------------
    // CONFIRMATION
    // ------------------------------------------------------------

    this.dialogService.open(

      "Êtes-vous sûr de vouloir supprimer ce message ?",

      environment.warning_message_type,

      'danger',

      environment.warning_icon,

      true

    ).then((result: any) => {


      console.log(
        '🟡 Résultat confirmation suppression :',
        result
      );


      if (!result) {

        console.log(
          '❌ Suppression annulée par utilisateur'
        );

        return;
      }


      console.log(
        '🗑️ Suppression confirmée'
      );


      // ----------------------------------------------------------
      // APPEL BACKEND
      // ----------------------------------------------------------

      console.log(
        '📡 Appel chatService.delete()'
      );

      console.log(
        '📩 messageId :',
        messageId
      );

      console.log(
        '👤 userId :',
        this.currentUserId
      );


      this.chatService
        .delete(
          messageId,
          this.currentUserId!
        )

        .subscribe({

          // ======================================================
          // SUCCESS
          // ======================================================

          next: (response: any) => {

            console.log('');
            console.log(
              '================================================'
            );

            console.log(
              '✅ RÉPONSE COMPLÈTE DU BACKEND'
            );


            console.log(
              '📩 Message ID :',
              messageId
            );


            console.log(
              '📦 Response complète :',
              response
            );


            console.log(
              '📦 JSON Response :',
              JSON.stringify(
                response,
                null,
                2
              )
            );


            // ----------------------------------------------------
            // FLAGS SUPPRESSION
            // ----------------------------------------------------

            console.log(
              '🗑️ deletedForSender :',
              response?.deletedForSender
            );


            console.log(
              '🗑️ deletedForReceiver :',
              response?.deletedForReceiver
            );


            // ----------------------------------------------------
            // VÉRIFICATION EXPLICITE
            // ----------------------------------------------------

            if (
              response?.deletedForSender === true
            ) {

              console.log(
                '✅ CONFIRMATION : message supprimé POUR LE SENDER'
              );

            }


            if (
              response?.deletedForReceiver === true
            ) {

              console.log(
                '✅ CONFIRMATION : message supprimé POUR LE RECEIVER'
              );

            }


            if (
              response?.deletedForSender === true &&
              response?.deletedForReceiver === true
            ) {

              console.log(
                '🔥 CONFIRMATION : message supprimé POUR LES DEUX'
              );

              console.log(
                '🔥 Le backend devrait avoir supprimé définitivement le message de la BDD'
              );

            }


            // ----------------------------------------------------
            // RETROUVER MESSAGE AVANT FILTRAGE
            // ----------------------------------------------------

            console.log(
              '📋 Messages AVANT suppression locale :',
              this.messages
            );


            // ----------------------------------------------------
            // SUPPRESSION LOCALE
            // ----------------------------------------------------

            this.messages =
              this.messages.filter(
                m => m.id !== messageId
              );


            console.log(
              '🧹 Message retiré de la liste locale'
            );


            console.log(
              '📋 Messages APRÈS suppression locale :',
              this.messages
            );


            // ----------------------------------------------------
            // RECHARGEMENT LAST MESSAGES
            // ----------------------------------------------------

            console.log(
              '🔄 Rechargement des derniers messages après suppression...'
            );


            this.loadLastMessages();
            window.location.reload();
  
          },


          // ======================================================
          // ERROR
          // ======================================================

          error: (err) => {

            console.error('');
            console.error(
              '================================================'
            );

            console.error(
              '❌ ERREUR SUPPRESSION MESSAGE'
            );


            console.error(
              '📩 Message ID :',
              messageId
            );


            console.error(
              '👤 User ID :',
              this.currentUserId
            );


            console.error(
              '❌ Erreur complète :',
              err
            );


            console.error(
              '❌ Status HTTP :',
              err?.status
            );


            console.error(
              '❌ Error body :',
              err?.error
            );


            console.error(
              '================================================'
            );

          }

        });

    });

  }


  // ============================================================
  // FILTER USERS
  // ============================================================

  filteredUsers(): AppUserDTO[] {

    if (!this.searchTerm.trim()) {

      return this.availableUsers;

    }


    const term =
      this.searchTerm.toLowerCase();


    return this.availableUsers.filter(
      u =>
        u.name
          .toLowerCase()
          .includes(term)
    );

  }


  // ============================================================
  // TOTAL UNREAD
  // ============================================================

  get totalUnreadMessages(): number {

    const total =
      Object.values(
        this.unreadCounts
      ).reduce(
        (sum, count) =>
          sum + count,
        0
      );


    console.log(
      '🔢 TOTAL UNREAD :',
      total
    );


    return total;

  }


  // ============================================================
  // ROOM ID
  // ============================================================

  private generateRoomId(
    user1: number,
    user2: number
  ): string {

    const roomId =
      [user1, user2]
        .sort()
        .join('_');


    console.log(
      '🏠 RoomId généré :',
      {
        user1,
        user2,
        roomId
      }
    );


    return roomId;

  }


  // ============================================================
  // DESTROY
  // ============================================================

  ngOnDestroy(): void {

    console.log('');
    console.log(
      '================================================'
    );

    console.log(
      '🛑 DESTRUCTION CHAT COMPONENT'
    );


    console.log(
      '🧹 Nombre subscriptions :',
      this.subscriptions.length
    );


    this.subscriptions.forEach(
      sub => sub.unsubscribe()
    );


    console.log(
      '🔌 Déconnexion WebSocket...'
    );


    this.chatService.disconnect();


    console.log(
      '✅ Chat component détruit'
    );

    console.log(
      '================================================'
    );

  }

}